module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/truck.4ec8a366.svg";